import { Spin } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { GalleryItemHelper } from '../GalleryItem/helpers';
import { GalleryImageCollectionItem } from '../GalleryPane/typings';

import './GallerySmallPreview.css';

export const PREVIEW_BLOCK = 'gallery-small-preview';

interface GallerySmallPreviewProps {
    item: GalleryImageCollectionItem;
}

interface GallerySmallPreviewState {
    isLoaded: boolean;
}

export class GallerySmallPreview extends React.PureComponent<GallerySmallPreviewProps, GallerySmallPreviewState> {
    state: GallerySmallPreviewState = {
        isLoaded: false
    };

    render() {
        const smallPreviewSizes = GalleryItemHelper.calcSmallPreviewSizes(this.props.item);
        const { isLoaded } = this.state;

        return (
            <div
                className={Bem.cls({
                    block: PREVIEW_BLOCK,
                    mods: { loaded: isLoaded ? 'yes' : 'no' }
                })}
                style={smallPreviewSizes}
            >
                <div className={Bem.cls(PREVIEW_BLOCK, 'content')}>
                    <img
                        className={Bem.cls(PREVIEW_BLOCK, 'image')}
                        src={this.props.item.thumbnailUrl}
                        onLoad={this.handleImageLoaded}
                    />
                </div>
                {!isLoaded && <Spin cls={Bem.cls(PREVIEW_BLOCK, 'spin')} size={'s'} progress={true} />}
            </div>
        );
    }

    private handleImageLoaded = () => {
        this.setState({ isLoaded: true });
    };
}
